const map = {
  'login': 'Login',
  'users': 'Usuaris',
  'new-m': 'Nou',
  'new-f': 'Nova',
  'edit': 'Editar',
  'detail': 'Detall',
  'summary': 'Resum',
  // *** Pages ***
  'live': 'Directe',
  'news': 'Noticies',
  'podcasts': 'Podcasts',
  'podcasts_groups': 'Grup de Podcasts',
  'push_notifications': 'Notificacions push',
  // *** Settings ***
  'settings': 'Configuració',
  'settings_params': 'Parámetres',
};

export const getText = (key) => {
  if (!map[key]) return '';
  return map[key];
}
